import { lazy } from "react";

const UserList = lazy(() => import("./UserList"));
const UsersLastLogin = lazy(() => import("./UsersLastLogin"));
const UserDetail = lazy(() => import("./UserDetail"));

const userRoutes = [
  { path: "/user/UserList", element: <UserList /> },
  { path: "/user/UsersLastLogin", element: <UsersLastLogin /> },
  { path: "/users/:id/:tab?", element: <UserDetail /> },
];

export default userRoutes;
